<div class="login-page">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordSubmit()">
        <div class="signin-wrapper justify-content-center align-items-center">
            <div class="card-signin mt-2">
                <div class="app-logo mt-1">
                    <img src="assets/img/PH-Logo-desktop.png" alt="App Logo">
                </div>
                <h1 class="text-center mb-4 mmt-3">Forgot your password?</h1>
                <p class="text-center mb-1">Please enter your Health Platform username/email below.</p>
                <p class="text-center m-0 mb-3">An email notification with password reset instructions will be sent to your registered email account.</p>
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <div class="form-group">
                            <label>Username/email</label>
                            <div class="input-icon">
                                <input type="text" class="form-control login-button" id="enterUsername" aria-describedby="emailHelp" formControlName="email" required autofocus
                                [ngClass]="{'is-invalid': submitted && f.email.errors}">
                                <div class="invalid-feedback">{{'Usernamerequired'|translate}}</div>
                            </div>
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                              <div *ngIf="f.email.errors.required">{{'Usernamerequired'|translate}}</div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-right">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-3 text-center">
                        <div class="form-group">
                            <button mat-raised-button color="primary" class="card-header-action mat-primary">
                              {{'Send request' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
  </div>